import axios from "axios";

const API_ROOT = process.env.REACT_APP_WP_API_URL;
const client = axios.create({
  baseURL: API_ROOT
});

export { client };
